import {
  FormField,
  FormGrid,
  FormRow,
  InfoCard,
  Link,
} from "@endya-conformite/ui-kit";

export function ControleQuinquennalExplainAxeGarantieFinanciereIas() {
  return (
    <FormGrid>
      <FormRow>
        <FormField>
          <InfoCard type="warning">
            Si vous faites appel à un expert-comptable,{" "}
            <b>
              simplifiez votre vérification en lui demandant de compléter{" "}
              <Link
                target="_blank"
                to="/Attestation_encaissement_de_fonds_ou_non_IAS_et_IOBSP.docx"
              >
                la présente attestation
              </Link>
            </b>
            . Il s&apos;agira du <b>seul</b> document à nous remettre. Les
            informations déclarées par ce <b>tiers de confiance</b> nous
            permettront de procéder aux vérifications de cohérence de la
            garantie financière.{" "}
          </InfoCard>
        </FormField>
      </FormRow>
      <FormRow>
        <FormField>
          <p>
            Si vous percevez, même à titre occasionnel, des fonds pour le compte
            de tiers (entreprise d&apos;assurance/assuré) dans le cadre de
            l&apos;activité d&apos;IAS, les documents sollicités ci-dessous
            permettront de vérifier la cohérence de la garantie financière
            souscrite avec les fonds réellement encaissés, déduction faite des
            mandats d&apos;encaissement.
          </p>
          <br />
          <p>
            Pièces à fournir, que vous perceviez ou non des fonds pour le compte
            ou à destination de tiers :
          </p>
          <ul>
            <li>
              Le(s) éventuel(s) mandat(s) exprès d&apos;encaissement régularisés
              avec une entreprise d&apos;assurance
            </li>
            <li>
              Attestation de votre expert-comptable ou commissaire aux comptes
              précisant le détail des fonds encaissés au sens des articles
              L.512-7 et A. 512-5 du code des assurances. (cf. modèle accessible
              dans la Base Documentaire)
            </li>
            <p>
              <b>OU</b>, à défaut, si vous n&apos;avez pas
              d&apos;expert-comptable ou commissaire aux comptes ou si ce
              dernier ne souhaite/peut pas compléter l&apos;attestation :
            </p>
            <li>
              Les comptes classes 4 et 5 de votre grand livre et votre bilan
              N-1.
            </li>
          </ul>
        </FormField>
      </FormRow>
    </FormGrid>
  );
}
